module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100vh",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "150px",
      "background-color": "black",
      "opacity": "0.7",
      "border-radius": "10px",
      "color": "white",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.time))])])])])]), _vm._v(" "), _c('StartupList'), _vm._v(" "), _c('TaskBar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2865fcf9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 149
// module chunks = 1